import { Component, Inject, Input, LOCALE_ID } from '@angular/core';

import { AppConfig } from '®shared/config';
import { CURRENT_USER, CurrentUserAndPermissions } from '®shared/current-user';
import { DigitisationStatus } from '®shared/list-item';
import { Permissions, UserPermissions } from '®shared/permissions';
import { EditableItem } from '®shared/reading-list/models/editable-item';

@Component({
  selector: 'rl-course-reserve-dates',
  templateUrl: './course-reserve-dates.component.html',
})
export class CourseReserveDatesComponent {
  @Input() item: EditableItem;

  permissions: UserPermissions;

  constructor(
    @Inject(CURRENT_USER) private currentUser: CurrentUserAndPermissions,
    @Inject(LOCALE_ID) public locale: string,
    private appConfig: AppConfig,
  ) {
    this.permissions = this.currentUser.permissions;
  }

  get isCourseReserveWorkflowEnabled(): boolean {
    return Boolean(
      this.appConfig.tenant.featureFlags.isCourseReserveWorkflowEnabled,
    );
  }

  get hasRequestCourseReservePermission(): boolean {
    return this.permissions.hasPermission(Permissions.REQUEST_COURSE_RESERVE);
  }

  get hasLiveCourseReserve(): boolean {
    if (!this.isCourseReserveWorkflowEnabled) {
      return false;
    }

    const digitisationStatus = this.item.content.status;
    return digitisationStatus === DigitisationStatus.LIVE;
  }

  get hasActiveCourseReserve(): boolean {
    if (!this.isCourseReserveWorkflowEnabled) {
      return false;
    }

    const digitisationStatus = this.item.content.status;
    return (
      digitisationStatus === DigitisationStatus.LIVE ||
      digitisationStatus === DigitisationStatus.PENDING
    );
  }

  get showCourseReserveDates(): boolean {
    if (!this.item.content.start_date || !this.item.content.end_date) {
      return false;
    }

    return (
      (this.hasRequestCourseReservePermission && this.hasActiveCourseReserve) ||
      (!this.hasRequestCourseReservePermission && this.hasLiveCourseReserve)
    );
  }
}
